import React from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputBase,
  withStyles,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
const BootstrapInput = withStyles((theme) => ({
  root: {},
  input: {
    color: "#898C98",
    borderRadius: 3,
    position: "relative",
    height: "1.2rem",
    border: "1px solid #E2E5EC",
    fontSize: "0.825rem",
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: ["poppins-medium"].join(","),
    "&:focus": {},
  },
}))(InputBase);
const StyledMenuItem = withStyles((theme) => ({
  root: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    "& .MuiListItemText-root": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "& .MuiListItemText-primary": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
}))(MenuItem);
const MNativeSelect = (props) => {
  const { options, nulloption, value, onChange, ...otherProps } = props;
  return (
    <div className="kissht-select">
      <FormControl style={{ minWidth: props.minwidth, width: "100%" }}>
        <Select
          value={value || ""}
          onChange={onChange}
          input={<BootstrapInput />}
          IconComponent={KeyboardArrowDownIcon}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                maxWidth: props.minwidth || "200px",
                width: props.minwidth || "200px",
              },
            },
          }}
          {...otherProps}
        >
          {nulloption && (
            <StyledMenuItem value="" title={nulloption}>
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
              >
                {nulloption}
              </span>
            </StyledMenuItem>
          )}
          {options &&
            Object.keys(options).map((key) => (
              <StyledMenuItem
                value={key}
                key={key}
                title={options[key]} // Shows full text on hover
              >
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "100%",
                  }}
                >
                  {options[key]}
                </span>
              </StyledMenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};
export default MNativeSelect;






